"use strict";const s=require("./index18.js"),e=require("./index21.js");var r=s._export,t=e.objectAssign;r({target:"Object",stat:!0,arity:2,forced:Object.assign!==t},{assign:t});
